function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.393 18.894c4.426.537 13.18.537 17.607-4.294-12.973-.358-15.753 1.073-17.607 4.294M18 7c7.945 3.082 6.487 7.257 6.487 12.096"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39 31.775C39 40.71 31 54 24 55.143 17 54 9 40.71 9 31.775c0-8.935 6.716-12.583 15-12.583s15 3.648 15 12.583z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.016
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 29v2M19 29v2M23 29v2M27 29v2M31 29v2M17 35v2M21 35v2M25 35v2M29 35v2M33 35v2M13 35v2M15 41v2M19 41v2M23 41v2M27 41v2M31 41v2M17 47v2M21 47v2M25 47v2M29 47v2M19 53v2M23 53v2M27 53v2",
  transform: "matrix(1 0 0 .96789 1 -3.069)"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.675 18.894c-4.426.537-13.18.537-17.607-4.294 12.973-.358 15.753 1.073 17.607 4.294",
  fill: "none",
  stroke: "var(--primary-color, #000)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17 15l-2-4c4.424-.016 6.564 3.945 9.5 6 2.484-3.44 5.196-5.948 8.5-6l-2 4",
  fill: "none",
  stroke: "var(--primary-color, #000)"
});

var SvgStrawberry = function SvgStrawberry(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStrawberry, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Strawberry.eaf4dcbb.svg";
export { ForwardRef as ReactComponent };